import React from "react";
import { keybindingsGlobalResume, keybindingsGlobalSuspend } from "../../keybindings/dispatcher";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function HeaderDialogSearchBox({
    setSearch
}: {
    setSearch: (search: string) => void
}) {
    return (<div>
        <input type="text"
            className="ryd-input"
            style={{
                width: '100%',
                boxSizing: 'border-box',
                marginBottom: '0px',
            }}
            onChange={(e) => setSearch(e.target.value.toLowerCase())}
            onFocus={keybindingsGlobalSuspend}
            onBlur={keybindingsGlobalResume}
        />
        <FontAwesomeIcon icon={faSearch}
            style={{
                position: 'relative',
                left: '-30px',
                top: '2px',
                color: '#888'
            }} />
    </div>);
}